<template>
  <div>
    <h4 class="hide-on-small-only">Painel</h4>
    <div class="row" style="margin: 0 -16px 24px -16px;">
    <div class="col s12 m8">
        <div class="small">
          Mostrar: <a href="#" @click="setPeriod(10)">Últimos 10 Dias</a> | <a href="#" @click="setPeriod(30)" >Últimos 30 Dias</a> | <a href="#" @click="setPeriod(90)">Últimos 90 Dias</a> | <a href="#" @click="setPeriod(0)">Todo o período</a> 
        </div>
    </div>
  </div>
    <div class="row" style="margin: 0 -16px 24px -16px;">
      <div class="col s12 m4">
        <div class="card-panel">
          <div class="box-data">
            <img src="@/assets/icons/total-quiz.svg" alt="" height="60" />
            <div class="box-text">
              <p class="title">{{ data.total_quizzes }}</p>
              <p class="description">Total de Questionários</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 m4">
        <div class="card-panel">
          <div class="box-data">
            <img src="@/assets/icons/resp-quiz.svg" alt="" height="60" />
            <div class="box-text">
              <p class="title" style="color:#37c57f">
                {{ data.total_answers }}
              </p>
              <p class="description">Total de Respostas</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 m4">
        <div class="card-panel">
          <div class="box-data">
            <img src="@/assets/icons/question.svg" alt="" height="60" />
            <div class="box-text">
              <p class="title" style="color: #d2d54e">
                {{ data.total_questions }}
              </p>
              <p class="description">Total de Questões</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <bar-chart v-if="!load" :chartData="options" />
  </div>
</template>

<script>
import BarChart from "@/components/BarChart";
import hashColor from "@/services/mixins/hashColor"

export default {
  name: "Panel",
  components: {
    BarChart
  },
  mixins: [hashColor],
  data: () => ({
    load: true,
    data: {},
    options: {},
    period: 0,
  }),
  mounted() {
    this.getIndicators();
  },
  methods: {
    async getIndicators() {
      const loader = this.$loading.show({
        loader: "spinner",
        width: 50,
        backgroundColor: "#000",
        color: "#fff"
      });
      try {
        const resp = await this.$http.get("dashboard?period=" + this.period);
        this.data = resp.data.data.dashboard;

        this.options = {
          labels: ["Questionário / Resposta"],
          datasets: this.data.answers_by_quiz.map(val => ({
            label: val.name,
            backgroundColor: this.hashStringToColor(val.name),
            data: [val.total, 0]
          }))
        };
      } catch (e) {
        console.error(e);
      }

      this.load = false;
      loader.hide();
    },
    setPeriod(value) {
      this.period = value;
      this.load = true;
      this.getIndicators();
    }
  }
};
</script>

<style lang="scss" scoped>
.card-panel {
  margin-bottom: 16px;
}

.box-data {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;

  img {
    margin: 8px;
  }

  .box-text {
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      margin: 0 24px;
      color: #2364a2;
      font-size: 40px;
      font-weight: bold;
    }
    .description {
      margin: 16px 0 0 0;
      text-align: center;
      white-space: nowrap;
      padding: 0 16px;
    }
  }
}
</style>
